import {Route, Routes} from "react-router-dom";

import SettlementSettingsIndex from './SettlementSettings/Index';
import SettlementSettingsNew from './SettlementSettings/New';
import SettlementSettingsEdit from './SettlementSettings/Edit';

import SettlementSales from "./SettlementSales";
import ZettleSales from "./ZettleSales";
import SettlementResult from "./SettlementResult";
import Index from "./Index";
import {canAccess} from "../../Utils/CanAccess";
import {useUserContext} from "../../Providers/UserContextProvider";
import ShopifyOrderIntegrationsIndex from "./ShopifyOrderIntegrations/Index";
import ShopifyOrderIntegrationsNew from "./ShopifyOrderIntegrations/New";
import ShopifyOrderIntegrationsEdit from "./ShopifyOrderIntegrations/Edit";

const SettlementRoutes = () => {

    const { user } = useUserContext();

    return (
        <Routes>
            <Route path={`/settlementResult`} element={<SettlementResult/>}/>
            <Route path={`/settlementSales`} element={<SettlementSales/>}/>
            <Route path={`/zettleSales`} element={<ZettleSales/>}/>
            
            {canAccess(user.permissions, 'Admin') && (
                <>
                    <Route path={`/settlementSettings/new`} element={<SettlementSettingsNew/>}/>
                    <Route path={`/settlementSettings/edit/:id`} element={<SettlementSettingsEdit/>}/>
                    <Route path={`/settlementSettings`} element={<SettlementSettingsIndex/>}/>

                    <Route path={`/shopifyOrderIntegrations`} element={<ShopifyOrderIntegrationsIndex />}/>
                    <Route path={`/shopifyOrderIntegrations/new`} element={<ShopifyOrderIntegrationsNew />}/>
                    <Route path={`/shopifyOrderIntegrations/edit/:id`} element={<ShopifyOrderIntegrationsEdit />}/>

                    <Route path={`/`} element={<Index />}/>
                </>
            )}
        </Routes>
    )
}

export default SettlementRoutes
